(function ($, Drupal) {
  Drupal.behaviors.hideSubmitButtonIfEmpty = {
    attach: function (context, settings) {
      var $filterDiv = $("#edit-field-mag-tag-selective--2", context);
      var $submitButton = $("#edit-submit-global-search-page--2", context);
      if ($filterDiv.length && $submitButton.length) {
        // Vérifie si la div est vide
        if (($filterDiv.text().trim() !== "" || $filterDiv.children().length > 0)) {
          $submitButton.show();
        }
      }
    }
  };
})(jQuery, Drupal);
DJ.addBehavior('search', '.site-search-backdrop', {

  attach: function (context, settings, behavior) {

    $backdrop = jQuery('.site-search-backdrop');
    $siteSearch = jQuery('#site-search');
    $search = jQuery('[data-drupal-selector="biogaran-search-global-form"]');
    $hero = jQuery('[data-drupal-selector="biogaran-search-hero-form"]');
    const $global = $search.find('[data-drupal-selector="edit-key"]').data('ui-autocomplete').menu.element;
    $global.addClass('biogaran-search-global-autocomplete-search');
    $global.addClass('opened');
    $search.find('[data-drupal-selector="edit-key"]').data('ui-autocomplete').menu.options.disabled = true;
    $search.find('[data-drupal-selector="edit-key"]').data('ui-autocomplete').options.position = { my: "left top+30", at: "left bottom", collision: "none" };
    $search.find('[data-drupal-selector="edit-key"]').data('ui-autocomplete')
      ._renderMenu = _renderMenu

    if ($hero.length) {
      const $element = $hero.find('[data-drupal-selector="edit-key"]').data('ui-autocomplete').menu.element;
      $element.addClass('biogaran-search-hero-autocomplete-search');
      $element.addClass('opened');
      $hero.find('[data-drupal-selector="edit-key"]').data('ui-autocomplete')
        ._resizeMenu = function () {
          this.menu.element.outerWidth($hero.outerWidth());
        }
      $hero.find('[data-drupal-selector="edit-key"]').data('ui-autocomplete').menu.options.disabled = true;
      $hero.find('[data-drupal-selector="edit-key"]').data('ui-autocomplete').options.position = { my: "left top+5", at: "left bottom", collision: "none" };
      $hero.find('[data-drupal-selector="edit-key"]').data('ui-autocomplete')
        ._renderMenu = function (ul, items) {
          if (items[0].value === 'noResults') {
            return;
          }
          ul.append('<h3>Suggestions</h3>');

          jQuery.each(items, function (index, item) {
            jQuery('<li>').append(jQuery(`<a href='${item.url}'>`).html(item.label)).appendTo(ul);
          });
        }

      $hero.find('[type="reset"]').on('click', function (e) {
        e.preventDefault();

        $element.removeClass('opened');
        $hero.find('[type="text"]').val('').focus();
      });

      $hero.on('submit', function (e) {
        const search = $hero.find('[type="text"]').val();

        if (!search) {
          e.preventDefault();

          jQuery('.search-page__count').html('Veuillez saisir votre recherche.');
        }
      });
    }

    function _renderMenu(ul, items) {
      if (items[0].value === 'noResults') {
        ul.append('Aucun résultat trouvé pour votre recherche. Veuillez saisir une nouvelle recherche')

        return;
      }
      ul.append('<h3>Suggestions</h3>');

      jQuery.each(items, function (index, item) {
        jQuery('<li>').append(jQuery(`<a href='${item.url}'>`).html(item.label)).appendTo(ul);
      });
    }

    function close() {
      $siteSearch.attr('hidden', true);
      $backdrop.attr('hidden', true);

      $global.removeClass('opened');
      bodyScrollLock.clearBodyLocks();
    }

    jQuery('.magnifying-glass .opener').on('click', function () {
      $siteSearch.removeAttr('hidden');
      $backdrop.removeAttr('hidden');

      bodyScrollLock.lock($global.get(0));
    });

    jQuery('.site-search-backdrop').on('click', close);

    $search.find('[type="reset"]').on('click', function (e) {
      e.preventDefault();

      $global.removeClass('opened');
      $search.find('[type="text"]').val('').focus();
    });

    $search.find('[type="text"]').on('input', function () {
      jQuery('.site-search--error').remove();
    });

    $search.find('[type="text"]').on('blur', function () {
      jQuery('.site-search--error').remove();
    });

    $search.on('submit', function (e) {
      const search = $search.find('[type="text"]').val();

      if (!search) {
        jQuery('<div class="site-search--error"><div class="site-search--error-text">Veuillez saisir votre recherche.</div></div>').appendTo($siteSearch);

        e.preventDefault();
      }
    });
  },

  detach: function (context, settings) { }
});
